import ISupplierSettings from "@models/ISupplierSettings";
import ITokenSettings from "@models/ITokenSettings";
import ScreenOptionsEnum from "@models/ScreenOptionsEnum";
import { IFilterPreset } from "@models/IFilterPresets";
import { IFilterPresetRuntime } from "@models/IFilterPresetsUI";

/**
 * Merge team-level and user-level presets into a single runtime array.
 * Team presets appear first, then user presets.
 * The `source` and `editable` fields are added at runtime — never stored.
 */
export function mergePresets(
    supplierSettings: ISupplierSettings | undefined | null,
    tokenSettings: ITokenSettings | undefined | null,
    screenKey: ScreenOptionsEnum,
    isAdmin: boolean
): IFilterPresetRuntime[] {
    const teamPresets = supplierSettings?.filterPresets?.[screenKey] || [];
    const userPresets = tokenSettings?.filterPresets?.[screenKey] || [];

    return [
        ...teamPresets.map((p) => ({
            ...p,
            source: "team" as const,
            editable: isAdmin,
        })),
        ...userPresets.map((p) => ({
            ...p,
            source: "user" as const,
            editable: true,
        })),
    ];
}

/**
 * Strip the runtime-only fields before persisting a preset.
 * The API's FilterPresetService rejects any preset key other than id/name/isDefault/filters.
 */
export function stripRuntimePreset(preset: IFilterPresetRuntime): IFilterPreset {
    const stored: IFilterPreset = {
        id: preset.id,
        name: preset.name,
        filters: preset.filters,
    };

    if (preset.isDefault) {
        stored.isDefault = true;
    }

    return stored;
}
